<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="primary" class="ml-3">
        Relatório Mensal
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Baixar Relatório Mensal</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              v-model="filter.dataInicialString"
              v-mask="'##/##/####'"
              label="Data de Início"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="filter.dataFinalString"
              v-mask="'##/##/####'"
              label="Data de Término"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              v-model="filter.responsavelMunicipio"
              :label="`Responsável do ${isGov ? 'Projeto' : 'Município'}`"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              v-model="filter.observacoes"
              label="Observações e Comentários"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-if="estado === 'MS'">
        <v-row>
          <v-col align="center">
            <v-checkbox v-model="filter.Baixar" label="Baixar"></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="filter.Email"
              label="Enviar por e-mail"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row v-if="filter.Email">
          <v-col>
            <v-select
              v-model="filter.Destinatarios"
              :items="membros"
              chips
              label="Destinatários"
              item-text="nome"
              multiple
              :return-object="true"
            >
              <template slot="no-data"> Nenhum destinatário </template>
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn
          v-if="estado === 'MS'"
          color="info"
          outlined
          text
          @click="download()"
          >Baixar / Enviar Report</v-btn
        >
        <v-btn v-else color="info" outlined text @click="download()"
          >Baixar Report</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { reportAPI } from "@/modules/report/API/ReportAPI";
import { memberAPI } from "@/modules/city/components/MemberAPI";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalReport",
  props: {
    municipioId: { required: true },
  },
  computed: {
    ...mapGetters(["city", "isGov"]),
  },
  data() {
    return {
      membros: [],
      estado: this.$store.state.uf,
      dialog: false,
      filter: {
        municipioId: this.municipioId,
        dataInicialString: "",
        dataFinalString: "",
        observacoes: "",
        responsavelMunicipio: "",
        nome: "",
        Baixar: true,
        Email: false,
      },
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    getMembers() {
      memberAPI
        .getMembersByCity(this.filter.municipioId)
        .then((resp) => {
          this.membros = resp.data;
        })
        .catch((resp) => {
          this.$notification.error("Erro ao obter destinatários");
        });
    },
    download() {
      this.setLoading(true);
      this.filter.nome = this.city;
      this.filter.sigla = this.$store.state.uf;
      if (this.filter.Email) {
        this.filter.destinatariosString = "";
        for (var i = 0; i < this.filter.Destinatarios.length; i++) {
          this.filter.destinatariosString =
            this.filter.destinatariosString +
            this.filter.Destinatarios[i].email;
          if (i + 1 < this.filter.Destinatarios.length) {
            this.filter.destinatariosString =
              this.filter.destinatariosString + ",";
          }
        }
      }

      reportAPI
        .getReport(this.filter)
        .then((resp) => {
          if (this.filter.Baixar) {
            let blob = new Blob([resp.data], { type: "application/pdf" });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Relatorio Mensal - " + this.city + ".pdf";
            link.click();
          }
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatório mensal");
        });
    },
  },
  mounted() {
    this.getMembers();
  },
};
</script>
